import * as React from 'react';

import { Box, Text } from '../../../design-system';

export const Loading = () => (
  <Box m="xl">
    <Text>Loading...</Text>
  </Box>
);
